/* eslint-disable react-hooks/exhaustive-deps */
import { Fragment, useEffect, useState } from "react"
import { toast } from "react-toastify"
import { FaTimesCircle } from "react-icons/fa"
import { useDispatch, useSelector } from "react-redux"

import { useStateContext } from "../../../state/context"
import { assignPharmacistToSupplyPoint, getPharmacistProfiles } from "../../../state/actions/pharmacist.actions"
import ButtonLoader from "../../utils/ButtonLoader"


const PharmacistAssignSupplyPointModal = () => {
    const dispatch = useDispatch()

    const { modals, setModals } = useStateContext()

    const { user } = useSelector(state => state.auth)
    const { supplyPoints, pharmacist_profiles, pharmacistLoading } = useSelector(state => state.pharmacist)
    const [formData, setFormData] = useState({ email: "", supplypoint: 0 })
    const [searching, setSearching] = useState(false)
    const [profiles, setProfiles] = useState([])

    useEffect(() => {
        dispatch(getPharmacistProfiles())
    }, [])

    useEffect(() => {
        if (formData.email.length <= 0) setSearching(false)

    }, [formData.email])

    const handleChange = (e, name) => {
        setFormData((prevState) => ({ ...prevState, [name]: e.target.value }))

        const filtered = pharmacist_profiles?.filter(profile => profile.user !== user?.data?.pkid)?.filter(profile => profile.details.email.includes(e.target.value))
        setProfiles(filtered)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!formData.email) return toast.warning('All fields are required!')
        dispatch(assignPharmacistToSupplyPoint({ formData, toast, setModals, modals }))
    }

    return (
        <div className="fixed grid h-screen w-full z-10 bg-[#11111180] place-items-center">
            <div className="bg-white w-[614px] rounded px-[30px] py-[20px]">
                <div className="flex flex-col space-y-5">
                    <div className="flex justify-between items-center">
                        <h4 className={`text-sky-500 text-[20px] font-bold capitalize`}>
                            Assign Pharmacist To Supplypoint
                        </h4>
                        <FaTimesCircle
                            className="text-dark-yellow cursor-pointer"
                            onClick={() => {
                                // dispatch(setSupplyPoint({ data: null }))
                                modals.showPharmacistAssignSupplyPointModal && setModals({ ...modals, showPharmacistAssignSupplyPointModal: !modals.showPharmacistAssignSupplyPointModal })
                            }}
                            size={20}
                        />
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="relative">
                            <select
                                className="appearance-none w-full bg-gray-300 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded leading-tight focus:outline-none "
                                name="supplypoint"
                                onChange={(e) => handleChange(e, e.target.name)}
                            >
                                <option value="">Supply Point</option>
                                {supplyPoints?.map((item, index) => (
                                    <option
                                        key={`${item.id}`}
                                        value={item.pkid}
                                    >{item.name}</option>
                                ))}
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                <svg
                                    className="fill-current h-4 w-4"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                >
                                    <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                                </svg>
                            </div>
                        </div>

                        <div className="relative">
                            <input
                                type="text"
                                name="email"
                                autocomplete="off"
                                placeholder="Pharmacist Email"
                                className="border rounded w-full h-5 px-4 py-5 mt-2 hover:outline-none focus:outline-none focus:ring-blue-500 focus:ring-blue 5ounded"
                                value={formData.email}
                                onChange={(e) => {
                                    setSearching(true)
                                    handleChange(e, e.target.name)
                                }}
                            />

                            {searching && (
                                <div className="absolute bg-white w-full flex flex-col shadow-md rounded-b-md h-[200px] overflow-y-auto patient__prescriptions">
                                    <Fragment>
                                        {profiles?.map((item, index) => (
                                            <div
                                                key={`${index}`}
                                                className={`p-2 px-10 ${(index + 1) <= profiles.length && 'border-b-2 border-gray-200'} hover:bg-sky-200 hover:rounded-lg hover:scale-[0.96] ease-in duration-500`}
                                                onClick={() => {
                                                    setFormData({ ...formData, email: item.details.email })
                                                    setSearching(false)
                                                }}
                                            >
                                                <p className="cursor-pointer font-bold text-[12px]">
                                                    Pharm. {item.details.last_name} {item.details.first_name}
                                                    <span className="text-[10px] text-yellow-500 ml-2">{item.details.assigned_supplypoint && item.details.assigned_supplypoint?.name}</span>
                                                </p>
                                                <div className="flex space-x-5 py-[2px] rounded">
                                                    <p className="cursor-pointer text-sm">{item.details.email}</p>
                                                    <p className="cursor-pointer text-sm text-yellow-500"></p>
                                                </div>
                                            </div>
                                        ))}
                                    </Fragment>
                                </div>
                            )}
                        </div>


                        {!searching && (
                            <div className={`${searching ? 'mt-[80px]' : 'mt-4'}`}>
                                <button
                                    type="submit"
                                    className="inline-block w-[175px] px-6 py-2.5 bg-sky-600 text-white font-medium text-xs leading-tight rounded shadow-md hover:scale-90 transition duration-500 ease"
                                >
                                    {!pharmacistLoading ? ("Submit") : (<ButtonLoader />)}
                                </button>
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    )
}

export default PharmacistAssignSupplyPointModal